<template>
  <div class="v-container">
    <div class="v-page-header">复拍上传</div>
    <div class="v-header">
      <el-button @click="selectFiles" size="small" type="primary" :loading="addLoading">选择上传文件</el-button>
      <div class="v-form-tips v-color-red">建议使用谷歌（Chrome）浏览器</div>
      <div class="v-form-tips v-color-red">上传队列最多允许上传500个文件，实际允许最大队列数量可能受到本地存储空间大小及浏览器限制</div>
      <div class="v-form-tips v-color-red">上传过程中请保证当前页面不被关闭</div>
      <div class="v-form-tips v-color-red">上传队列文件已被缓存，如遇报错或网络故障可刷新浏览器，任务会自动继续执行</div>
      <input ref="inputfile" hidden type="file" multiple accept="*/image" />
      <div class="header-control">
        <el-tabs class="header-control-tabs" v-model="activeTab" @tab-click="changeTab">
          <el-tab-pane :label="`任务列表(${lists.length})`" name="doing"></el-tab-pane>
          <el-tab-pane :label="`完成列表`" name="done"></el-tab-pane>
          <el-tab-pane :label="`失败列表`" name="fail"></el-tab-pane>
        </el-tabs>
        <div class="header-btns">
          <template v-if="activeTab == 'doing'">
            <el-button v-if="!uping" :disabled="lists.length == 0" class="control-btn" size="small" type="success" icon="el-icon-video-play" @click="startUp">开始上传</el-button>
            <el-button v-if="uping" :disabled="lists.length == 0" class="control-btn" size="small" type="danger" icon="el-icon-video-pause" @click="uping = false">暂停上传</el-button>
          </template>
          <template v-if="activeTab == 'done' || activeTab == 'fail'">
            <el-popconfirm title="确认删除？" @onConfirm="deleteDoneList()">
              <el-button :disabled="selection.length == 0" class="control-btn" size="small" type="danger" slot="reference" :loading="doneDeleteLoading">批量删除</el-button>
            </el-popconfirm>
          </template>
        </div>
      </div>
    </div>
    <div class="v-content">
      <el-table ref="doneTable" v-show="activeTab == 'doing'" v-loading="loading" size="small" border :data="lists" height="100%">
        <el-table-column label="文件名称" prop="name" />
        <el-table-column label="文件大小" prop="size" width="200">
          <template slot-scope="scope">{{ (scope.row.size / 1024 / 1024).toFixed(2) }}M</template>
        </el-table-column>
        <el-table-column label="上传时间" width="270">
          <template slot-scope="scope">{{ moment(scope.row.createTime).format('YYYY-MM-DD HH:mm:ss') }}</template>
        </el-table-column>
        <el-table-column label="上传状态" prop="appid" width="200" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1" class="v-color-gray">等待图片上传</span>
            <span v-if="scope.row.status == 2" class="v-color-yellow">图片上传中({{ scope.row.percent || 0 }}%)</span>
            <span v-if="scope.row.status == 3" class="v-color-blue">数据上传中...</span>
            <span v-if="scope.row.status == 4" class="v-color-red">上传失败,请重新上传</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="80">
          <template slot-scope="scope">
            <el-popconfirm title="确认删除？" @onConfirm="deleteStore(scope.row)">
              <el-button :disabled="scope.row.status == 2 || scope.row.status == 3" slot="reference" size="min" class="v-ml-5" type="danger" :loading="scope.row.deleteLoading">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <el-table v-if="activeTab == 'done'" ref="doneTable" v-loading="doneLoading" border size="small" :data="doneLists" height="100%" @selection-change="(value) => (selection = value)">
        <el-table-column type="selection" width="55" />
        <el-table-column label="ID" prop="id" width="60" />
        <el-table-column label="文件名称" prop="name" />
        <el-table-column label="经度" prop="longitude" width="100" />
        <el-table-column label="纬度" prop="latitude" width="100" />
        <el-table-column label="完成时间" width="270">
          <template slot-scope="scope">{{ moment(scope.row.update_time).format('YYYY-MM-DD HH:mm:ss') }}</template>
        </el-table-column>
      </el-table>
      <el-table v-if="activeTab == 'fail'" ref="failTable" v-loading="failLoading" border size="small" :data="failList" height="100%" @selection-change="(value) => (selection = value)">
        <el-table-column type="selection" width="55" />
        <el-table-column label="ID" prop="id" width="60" />
        <el-table-column label="图片" width="122">
          <tempalate slot-scope="scope">
            <a :href="scope.row.key_preview" target="_blank" style="color: #333">
              <el-image :src="scope.row.key_preview + '?imageView2/2/w/200/h/100'" style="width: 100px; height: 50px; display: block">
                <div slot="placeholder" class="image-slot">
                  加载中
                  <span class="dot">...</span>
                </div>
              </el-image>
            </a>
          </tempalate>
        </el-table-column>
        <el-table-column label="文件名称" prop="name" />
        <el-table-column label="经度" prop="longitude" width="100" />
        <el-table-column label="纬度" prop="latitude" width="100" />
        <el-table-column label="失败时间" width="150">
          <template slot-scope="scope">{{ moment(scope.row.update_time).format('YYYY-MM-DD HH:mm:ss') }}</template>
        </el-table-column>

        <el-table-column label="失败原因" prop="reson" width="200" />
      </el-table>
    </div>
    <div v-if="activeTab == 'done'" class="v-footer">
      <el-pagination
        layout="total,sizes,prev, pager, next"
        @size-change="
          (page_size) => {
            getDoneList(page, page_size);
          }
        "
        @current-change="
          (page) => {
            getDoneList(page);
          }
        "
        :current-page.sync="page"
        :page-size="100"
        :page-sizes="[100, 200, 300, 400]"
        :total="doneTotal"
      />
    </div>
    <div v-if="activeTab == 'fail'" class="v-footer">
      <el-pagination
        layout="total,sizes,prev, pager, next"
        @size-change="
          (page_size) => {
            getFailList(page, page_size);
          }
        "
        @current-change="
          (page) => {
            getFailList(page);
          }
        "
        :current-page.sync="pageFail"
        :page-size="20"
        :page-sizes="[20, 50, 100, 200, 300, 400]"
        :total="failTotal"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import upload from '@/utils/upload';
import indexdb from './indexdb';

export default {
  data() {
    return {
      page: 1,
      pageFail: 1,
      pageSize: 100,
      pageSizeFail: 20,
      lists: [],
      doneLists: [],
      failList: [],
      doneTotal: 0,
      failTotal: 0,
      loading: false,
      addLoading: false,
      doneLoading: false,
      failLoading: false,
      max: 5,
      uping: false,
      activeTab: 'doing',
      selection: [],
      doneDeleteLoading: false,
    };
  },

  created() {
    this.getList();
    window.addEventListener('beforeunload', this.beforeunload);
  },

  beforeRouteLeave(to, from, next) {
    if (this.lists.filter((item) => item.status == 2 || item.status == 3).length) {
      this.$confirm('复拍任务执行中，确认要离开么？').then(() => {
        next();
      });
    } else {
      next();
    }
  },

  methods: {
    moment,

    beforeunload(e) {
      if (this.lists.filter((item) => item.status == 2 || item.status == 3).length) {
        let message = '复拍任务执行中，确认要离开么？';
        (e || window.event).returnValue = message;
        return message;
      }
    },

    changeTab() {
      this.selection = [];
      if (this.activeTab == 'done') {
        this.getDoneList();
        this.$nextTick(() => {
          this.$refs.doneTable.doLayout();
        });
      }
      if (this.activeTab == 'fail') {
        this.getFailList();
        this.$nextTick(() => {
          this.$refs.failTable.doLayout();
        });
      }
    },

    async getList() {
      this.loading = false;
      try {
        let res = await this.getCursorList();
        this.lists = res;
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },

    async getDoneList(page, pageSize) {
      this.doneLoading = true;
      this.page = page ? page : this.page;
      this.pageSize = pageSize ? pageSize : this.pageSize;
      try {
        let res = await this.api.works.getRetakeList({ page: this.page, page_size: this.pageSize });
        this.doneLists = res.data.data;
        this.doneTotal = res.data.total;
      } catch (e) {
        console.error(e);
      }
      this.doneLoading = false;
    },

    async getFailList(page, pageSize) {
      this.failLoading = true;
      this.pageFail = page ? page : this.pageFail;
      this.pageSizeFail = pageSize ? pageSize : this.pageSizeFail;
      try {
        let res = await this.api.works.retakeErrorData({ page: this.pageFail, page_size: this.pageSizeFail });
        this.failList = res.data.data;
        this.failTotal = res.data.total;
        console.log(this.failList);
      } catch (e) {
        console.error(e);
      }
      this.failLoading = false;
    },

    async deleteDoneList() {
      this.doneDeleteLoading = true;
      try {
        await this.api.works.deleteRetake({ ids: this.selection.map((item) => item.id) });
        this.getDoneList();
        this.getFailList();
      } catch (e) {
        console.error(e);
      }
      this.doneDeleteLoading = false;
    },

    startUp() {
      this.uping = true;
      this.addToUp();
    },

    async addToUp() {
      if (!this.uping) {
        return;
      }
      let watingFiles = this.lists.filter((item) => item.status == 1);
      let upingFiles = this.lists.filter((item) => item.status == 2 || item.status == 3);
      let row = watingFiles[0];
      if (watingFiles.length && upingFiles.length < this.max) {
        row.status = 2;
        console.log(row.name);
        this.doUp(row);
        this.addToUp();
      }
    },

    async doUp(row) {
      try {
        if (!row.key) {
          let res = await upload.uploadFile(row.file, {
            progress: (e) => {
              this.$set(row, 'percent', parseInt(e.total.percent));
            },
          });
          await this.putStore(row, 'key', res.key);
        }
        row.status = 3;
        await this.api.works.retake({ name: row.name, key: row.key });
        await this.deleteStore(row);
      } catch (e) {
        row.status = 4;
        await this.putStore(row, 'status', 4);
        console.error(e);
      }
      this.addToUp();
    },

    selectFiles() {
      let input = this.$refs.inputfile;
      input.click();
      input.onchange = async (e) => {
        let files = e.target.files;
        this.addLoading = true;
        try {
          let newAdded = await this.addStore(Array.from(files));
          this.lists = [...this.lists, ...newAdded];
        } catch (e) {
          console.error(e);
        }
        this.addLoading = false;
        input.value = '';
      };
    },

    getCursorList() {
      return new Promise((resolve) => {
        (async () => {
          let arr = [];
          let objectStore = await indexdb.getObjectStore();
          objectStore.openCursor().onsuccess = (e) => {
            let cursor = e.target.result;
            if (cursor) {
              arr.push({ id: cursor.key, ...cursor.value });
              cursor.continue();
            } else {
              resolve(arr);
            }
          };
        })();
      });
    },

    async addStore(data, files = []) {
      let objectStore = await indexdb.getObjectStore();
      let item = data[0];
      let obj = {
        file: item,
        name: item.name,
        size: item.size,
        createTime: new Date() * 1,
        status: 1, // 1等待图片上传 2图片上传中 3数据上传中 4上传失败
      };
      let res = objectStore.add(obj);
      await indexdb.requestSuccess(res);
      obj.id = res.result;
      files.push(obj);
      data = data.slice(1);
      if (data[0]) {
        return this.addStore(data, files);
      } else {
        return Promise.resolve(files);
      }
    },

    async putStore(row, key, value) {
      try {
        let objectStore = await indexdb.getObjectStore();
        let _row = Object.assign({}, row);
        _row[key] = value;
        delete _row.id;
        let request = objectStore.put(_row, row.id);
        row[key] = value;
        return await indexdb.requestSuccess(request);
      } catch (e) {
        console.error(e);
      }
    },

    async deleteStore(row) {
      this.$set(row, 'deleteLoading', true);
      try {
        let objectStore = await indexdb.getObjectStore();
        let res = objectStore.delete(row.id);
        await indexdb.requestSuccess(res);
        let index = this.lists.findIndex((item) => item.id == row.id);
        this.lists.splice(index, 1);
        if (this.lists.length == 0) {
          this.uping = false;
        }
      } catch (e) {
        console.error(e);
      }
      this.$set(row, 'deleteLoading', false);
    },
  },
};
</script>

<style scoped>
.header-control {
  position: relative;
}

.header-control .header-btns {
  position: absolute;
  top: 6px;
  right: 0;
}

.header-control ::v-deep .el-tabs__header {
  margin: 0;
}
.image-slot {
  background: #f5f7fa;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 50px;
  font-size: 12px;
}
</style>
